import React, { createRef } from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Box, Card, Typography, Icon } from "@bca/ui-library";
import { AnalyticsProps } from "@bca/ui-library/dist/analytics.types";

const StyledCard = styled(Card)`
  ${css({
    px: 4,
    pt: 7,
    pb: 22,
    m: 0,
  })}
`;

const Anchor = styled.a`
  text-decoration: none;
`;

interface Analytics extends AnalyticsProps {
  eventName: string;
  eventCategory?: string;
  eventLabel?: string;
}

interface MobileCardProps {
  icon: "flag" | "file-invoice";
  link: string;
  headline: string;
  description: string;
  ariaLabel: string;
  analytics?: Analytics;
}

export default function MobileCard({
  icon,
  link,
  headline,
  description,
  ariaLabel,
  analytics,
}: MobileCardProps) {
  const cardRef = createRef<HTMLLIElement>();
  const cardAnchorRef = createRef<HTMLAnchorElement>();

  return (
    <li
      style={{
        listStyleType: "none",
        width: "calc((100% - 20px) / 2)",
        height: "100%",
      }}
      ref={cardRef}
    >
      <Anchor
        href={link}
        target="_blank"
        ref={cardAnchorRef}
        aria-label={ariaLabel}
      >
        <StyledCard width="100%" height="100%" analytics={analytics}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Icon
              name={icon}
              color="footer-blue"
              weight="solid"
              width={24}
              height={24}
              m={0}
            />
            <Icon
              name="arrow-right"
              weight="solid"
              width={21}
              height={24}
              m={0}
              ml={6}
            />
          </Box>
          <Typography
            variant="body-lg"
            textAlign="left"
            color="footer-blue"
            mt={2}
            mb={2}
            fontWeight="medium"
          >
            {headline}
          </Typography>
          <Typography
            variant="body-small"
            color="grey-blue"
            textAlign="left"
            m={0}
            css={`
              line-height: 1.29;
            `}
          >
            {description}
          </Typography>
        </StyledCard>
      </Anchor>
    </li>
  );
}
